import React, { Component } from 'react';
import axios from 'axios';

import NewsletterFireworks from '../NewsletterFireworks';

class Slack extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trigger: false,
      error: false,
    };

    this.triggerNext = this.triggerNext.bind(this);
  }

  componentDidMount() {

    const { steps } = this.props;
    const message = steps.slackmessage.value;

    axios.post('/api/slack', {
      message: message,
    })
    .then((response) => {
      if(response.data) {
        this.setState({ loading: false });
      } else {
        // No feedback from server?
        this.setState({ loading: false, error: true });
      }
      // Continue
      setTimeout( () => {
        this.triggerNext();
      }, 1500);
    })
    .catch((error) => {
      // something went wrong
      this.setState({ loading: false, error: true });
      // Continue
      setTimeout( () => {
        this.triggerNext();
      }, 1500);
    });

  }

  triggerNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  render() {
    return (
      <div className="Slack">
        { this.state.loading ? (
          <p>Sending message...</p>
        ) : (
          <div>
            { this.state.error ? (
              <p>Error contacting Slack API <span role="img" aria-label="Skull">💀</span></p>
            ) : (
              <div className="Slack__result">
                <p>Message send! <span role="img" aria-label="Tada">🎉</span></p>
                <NewsletterFireworks />
              </div>
            ) }
          </div>
        ) }
      </div>
    )
  }
}

export default Slack